import { type InvestmentsRoutesEnum, type MarketInvestmentsRoutesEnum } from 'investments/common/enums'
import BlackBird from 'shared/blackbird'
import { stringFormat } from 'shared/format-utils'

import { timeMachine } from '~/domains/platform/lib/time-machine'

type UseStatementManageDatesParams = {
  pathname: InvestmentsRoutesEnum | MarketInvestmentsRoutesEnum
  urlParams?: Record<string, string | undefined>
}

export function useStatementManageDates({ pathname, urlParams }: UseStatementManageDatesParams) {
  const query = BlackBird.getQuery()

  const fromDate = query.fromDate ?? timeMachine().startOfMonth().format('defaultApi')
  const toDate = query.toDate ?? timeMachine().endOfMonth().format('defaultApi')
  const initialLimitDate = query.initialLimitDate ?? fromDate

  const isNextMonthDisabled = timeMachine(fromDate).startOfMonth().isSame(timeMachine().startOfMonth())
  const isPreviousMonthDisabled = timeMachine(initialLimitDate).startOfMonth().isSame(timeMachine(fromDate))

  function onViewPreviousMonth() {
    const currentDate = timeMachine(fromDate).subtractMonth(1).toDate()

    BlackBird.replace(
      {
        pathname,
        urlParams,
        query: {
          ...query,
          fromDate: timeMachine(currentDate).startOfMonth().format('defaultApi'),
          toDate: timeMachine(currentDate).endOfMonth().format('defaultApi')
        }
      },
      undefined,
      { scroll: false }
    )
  }

  function onViewNextMonth() {
    const currentDate = timeMachine(fromDate).addMonth(1).toDate()

    BlackBird.replace(
      {
        pathname,
        urlParams,
        query: {
          ...query,
          fromDate: timeMachine(currentDate).startOfMonth().format('defaultApi'),
          toDate: timeMachine(currentDate).endOfMonth().format('defaultApi')
        }
      },
      undefined,
      { scroll: false }
    )
  }

  const currentDate = stringFormat.capitalizeFirstLetter(
    timeMachine(fromDate).toDate().toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' }).replace(' de', ',')
  )

  return {
    fromDate,
    toDate,
    onViewPreviousMonth,
    onViewNextMonth,
    isNextMonthDisabled,
    isPreviousMonthDisabled,
    currentDate
  }
}
